// extracted by mini-css-extract-plugin
export default {"teacherContainer":"Subject_teacherContainer__Qhk2u","lessonsContainer":"Subject_lessonsContainer__K0sTu"};